<template>
  <div id="app" class="globalScrool">
    <router-view></router-view>
  </div>
</template>

<script>
import { getUserPermList } from './framework/API/common';
export default {
  name: "App",
  mounted() {
    setTimeout(() => {
      this.getRules();
    }, 300)
  },
  methods: {
    // 获取权限
    async getRules() {
      let source = 1;
      let urlSource = this.$route.query.source;
      let sessionSource = sessionStorage.getItem('source');
      if (urlSource != null && urlSource != undefined && urlSource != '') {
        source = urlSource
      } else if (sessionSource != null && sessionSource != undefined && sessionSource != '') {
        source = sessionSource
      } else  {
        source = 1
      }
      sessionStorage.setItem('source', source);
      let res = await getUserPermList({ platform: source });
      sessionStorage.setItem('userRules', JSON.stringify(res));
    },
  }
};
</script>
  
<style>
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  min-width: 1450px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue